import React from 'react'
import Base from '../core/Base'

function MyPaymentCard() {
    return (
        <Base>
        <div>
            <section className='text-center'>This Section Under construction</section>
        </div>
        </Base>
    )
}

export default MyPaymentCard
